import React from 'react';
import HeroSection from './HeroSection';
import IntroWriteup from '../components/IntroWriteup';
import DepartmentCards from './Stakeholders';
import SuccessStories from '../components/SuccessStories';
import PortalStats from '../components/PortalStats';

// Home page order (per client, Oct 2026):
//   1. Main banner — ஏரி இணையதளம்
//   2. Tamil & English write-up
//   3. Stakeholder Departments with water-body counts
//   4. Success Stories
//   5. Portal at a Glance (live stats)
// The old "About the Portal" section and image marquee are no longer shown.
const HomePage = () => {
  return (
    <div className="min-h-screen no-spacing">
      <style jsx>{`
        .no-spacing > * {
          margin: 0 !important;
        }
        .no-spacing > *:not(:last-child) {
          margin-bottom: 0 !important;
        }
      `}</style>

      <HeroSection />
      <IntroWriteup />
      <DepartmentCards />
      <SuccessStories />
      <PortalStats />
    </div>
  );
};
export default HomePage;
